import {AppBoundDataStorageHelper} from '@/helpers/LocalStorageHelpers/AppBoundDataStorageHelper';

export const SiteLocationStoreKey = 'LATEST_SLOCS_DATA';

export const SiteLocationHandler = {
    is_valid_site_location_item(item){
        if(item.name !== undefined && item.locationData !== undefined){
            return true;
        }
        return false;
    },
    get_valid_site_locations_data(data){
        let raw_data = [];
        if(data !== undefined && Array.isArray(data)){
            for(const i in data){
                if(this.is_valid_site_location_item(data[i])){
                    raw_data.push(data[i]);
                }
            }
        }
        return raw_data;
    },
    save_site_location_data(data){
        let raw_data = this.get_valid_site_locations_data(data);
        AppBoundDataStorageHelper.storeAppBoundDataForKey(SiteLocationStoreKey, raw_data);     
    },
    load_site_location_from_storage(){
        return AppBoundDataStorageHelper.getAppBoundDataForKey(SiteLocationStoreKey);
    }
}